import {GoogleOAuthProvider, useGoogleLogin} from '@react-oauth/google'
import useDrivePicker from 'react-google-drive-picker'
import DriverIcon from '../../../../assets/icons/drive.svg'
import {getLocalData, setLocalData} from '../../../../services/StorageServices'
import {toaster} from '../../../../shared/PFToast'
const REACT_APP_GOOGLEDRIVE_CLIENT_ID = process.env.REACT_APP_GOOGLEDRIVE_CLIENT_ID || ''
const REACT_APP_GOOGLEDRIVE_DEVELOPER_KEY = process.env.REACT_APP_GOOGLEDRIVE_DEVELOPER_KEY || ''

const GoogleDrivePicker = ({onFileSelect}) => {
    const [openPicker] = useDrivePicker()
    const googleToken = getLocalData('googleToken')
    const googleTokenExpiresAt = getLocalData('googleTokenExpiresAt')

    const login = useGoogleLogin({
        scope: `${process.env.REACT_APP_GOOGLE_URL}/auth/drive.readonly`,
        onSuccess: (tokenResponse) => {
            openDrivePicker(tokenResponse.access_token)
            setLocalData('googleToken', tokenResponse.access_token)
            setLocalData('googleTokenExpiresAt', Date.now() + tokenResponse.expires_in * 1000)
        },
        onError: () => {
            console.error('Google login failed')
        },
        flow: 'implicit',
    })

    const checkTokenAndRetry = async (operation) => {
        try {
            return await operation()
        } catch (error) {
            if (error.message.includes('401') || error.message.includes('invalid_token')) {
                // Token is expired or invalid, clear it and trigger new login
                setLocalData('googleToken', null)
                login()
                return
            }
            throw error
        }
    }

    const downloadGoogleDriveFile = async (file, accessToken) => {
        const {id, name, mimeType} = file
        const url = `${process.env.REACT_APP_GOOGLE_URL}/drive/v3/files/${id}?alt=media`

        try {
            await checkTokenAndRetry(async () => {
                const res = await fetch(url, {
                    headers: {Authorization: `Bearer ${accessToken}`},
                })

                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`)
                }

                const blob = await res.blob()
                const downloadedFile = new File([blob], name, {type: mimeType})
                onFileSelect([downloadedFile])
            })
        } catch (error) {
            toaster({
                type: 'error',
                message: 'An error occurred while uploading the image',
                duration: 10000,
                width: 370,
            })
        }
    }

    const openDrivePicker = (accessToken) => {
        if (!accessToken) {
            login()
            return
        }

        openPicker({
            clientId: REACT_APP_GOOGLEDRIVE_CLIENT_ID,
            developerKey: REACT_APP_GOOGLEDRIVE_DEVELOPER_KEY,
            viewId: 'DOCS',
            token: accessToken,
            supportDrives: true,
            viewMimeTypes: 'image/svg+xml,image/jpeg,image/png,image/jpg',
            multiselect: false,
            callbackFunction: (data) => {
                if (data.action === 'cancel') {
                    return
                } else {
                    if (!data.docs || data.docs.length === 0) return
                    downloadGoogleDriveFile(data.docs[0], accessToken)
                }
            },
        })
    }

    const handleOpenPicker = () => {
        if (googleToken && Date.now() < googleTokenExpiresAt) {
            openDrivePicker(googleToken)
        } else {
            login()
        }
    }

    return (
        <label
            htmlFor="inputUploadArtwork_computer11"
            id="inputUploadArtwork_computer11"
            className="mb-0 cursor-pointer align-items-center"
            onClick={handleOpenPicker}
        >
            <img src={DriverIcon} alt="driver-icon" className="mr-2" />
            Google Drive
        </label>
    )
}

const UploadByGoogleDrive = ({onFileSelect}) => (
    <GoogleOAuthProvider clientId={REACT_APP_GOOGLEDRIVE_CLIENT_ID}>
        <GoogleDrivePicker onFileSelect={onFileSelect} />
    </GoogleOAuthProvider>
)

export default UploadByGoogleDrive

